import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareAccentColorMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  accentColor?: Types.InputMaybe<Types.Scalars['HexColorCode']['input']>;
}>;


export type UpdateShareAccentColorMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, accentColor?: string | null } | { __typename?: 'CollectionShare', id: string, accentColor?: string | null } | null } | null };


export const UpdateShareAccentColor = /*#__PURE__*/ gql`
    mutation UpdateShareAccentColor($shareId: ID!, $accentColor: HexColorCode) {
  updateShare(input: {shareId: $shareId, settings: {accentColor: $accentColor}}) {
    share {
      id
      accentColor
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareAccentColorMutation, UpdateShareAccentColorMutationVariables>;

          

          export const useUpdateShareAccentColorMutation = (options?:MutationHookOptions<UpdateShareAccentColorMutation, UpdateShareAccentColorMutationVariables>) => useMutation(UpdateShareAccentColor, options);
          

          export type UpdateShareAccentColorMutationOptions = MutationHookOptions<UpdateShareAccentColorMutation, UpdateShareAccentColorMutationVariables>;

          

          export type UpdateShareAccentColorMutationResult = ReturnType<typeof useUpdateShareAccentColorMutation>[1];

          
